import ThankYouAddressModal from './ThankYouAddressModal'

export default ThankYouAddressModal
